import { signal } from "@angular/core";
import IDataStatus from "../interfaces/datastatus.interface";

export default class DataStatus implements IDataStatus {
    readonly completed = signal(false)
    readonly error = signal(false)
    readonly loading = signal(false)
    readonly empty = signal(false)
}
